import { render, staticRenderFns } from "./Promotion.vue?vue&type=template&id=14eb61e5&scoped=true"
import script from "./Promotion.vue?vue&type=script&lang=js"
export * from "./Promotion.vue?vue&type=script&lang=js"
import style0 from "./Promotion.vue?vue&type=style&index=0&id=14eb61e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14eb61e5",
  null
  
)

export default component.exports